export default __webpack_public_path__ + "static/media/btn-itunes.708f156b.png";